module.exports = __webpack_public_path__ + "img/test_news_image.ff441cdf.png";